import { useState, useEffect } from "react";
import DialogComponent from "../../../components/DialogComponent";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { selectItems, selectItem } from "src/modules/spItems/selectors";
import { fieldType } from "src/types/form";
import _ from 'lodash';
import Form from "src/components/Form";
import { selectUsers } from "src/modules/users/selector";
import { getItemsRequest } from "src/modules/spItems/api";
import { addUsers } from "src/modules/users/actions";
import { RootState } from "src/store/rootReducer";
import Loading from "src/components/Loading";
import { FlexCol } from "src/utils/flexLayouts";
import { approversCardDocumentListName, approversDependenciesListName, approversListName, myDocumentsListName, versionsByDocumentListName } from "src/api/config";
import { docApprovers, docStatuses } from "src/api/config/systemSwitch";

type Props = {
    open: boolean;
    dialogToggle: any;
    setOpen: any;
    setApprovers: any;
    collection: number;
    typeDocument: number;
    setApproversCardDocumentData: any;
    setShowEditApprovers: any;
    updateCardData?: any;
    approversList: any;
    card: any;
    versionView: any;
}

const EditApproversModal = (props: Props) => {

    const { setApprovers, open, setOpen, typeDocument, collection, dialogToggle, setApproversCardDocumentData, setShowEditApprovers, updateCardData, approversList, card, versionView } = props;
    const [approversByDocument, setApproversByDocument] = useState<any>([]);
    const [approversDependencies, setApproversDependencies] = useState<any>([]);
    const [fieldsForm, setFieldsForm] = useState<fieldType[]>([]);
    const [defaultValues, setDefaultValues] = useState<any>({});
    const dispatch = useAppDispatch();
    const users: any = useAppSelector(selectUsers);
    const statusUsers: string = useAppSelector((state: RootState) => state.users.status);

    useEffect(() => {
        if (typeDocument && collection) {
            getItemsRequest({ listName: approversDependenciesListName, filters: { DocType: typeDocument, Collection: collection }, sortOrder: { name: 'Order0', asc: true } }).then((results: any) => {
                if (results.items.length > 0) {
                    let usersEmail: any = [];
                    // @ts-ignore
                    results.items.forEach((item: any) => {
                        Object.keys(item).forEach((key) => {
                            const field = item[key];
                            if (field && !Array.isArray(field) && field.get_email) {
                                if (field.get_email()) {
                                    usersEmail = [...usersEmail, field.get_email().toLowerCase()];
                                }
                            }
                            if (field && Array.isArray(field) && field.length > 0 && field[0].get_email) {
                                field.forEach((user) => {
                                    if (user.get_email()) {
                                        usersEmail = [...usersEmail, user.get_email().toLowerCase()];
                                    }
                                });
                            }
                        });
                    });
                    usersEmail = _.uniqWith(usersEmail, _.isEqual);
                    if (usersEmail.length > 0) {
                        let actualEmails: any = [];
                        usersEmail.forEach((item: string) => {
                            let check = false;
                            Object.keys(users).forEach((key) => {
                                if (key === item) {
                                    check = true;
                                }
                            });
                            if (!check) {
                                actualEmails = [...actualEmails, item.toLowerCase()];
                            }
                        });
                        if (actualEmails) {
                            dispatch(addUsers(actualEmails));
                        }
                    }
                }
                setApproversDependencies([...results.items]);
            });
        }
    }, [typeDocument, collection]);

    useEffect(() => {
        if (approversDependencies.length > 0 && approversList.length > 0) {
            let filterApprovers = [...approversDependencies];
            filterApprovers = _.orderBy(filterApprovers, ['Order0'], ['asc']);
            const approversObj: any = {};
            filterApprovers.map((approversRowDependencies: any) => {
                const idApproversGroup = approversRowDependencies.Group.get_lookupId();
                const groupApprovers =
                    approversList.filter((item: any) => item.ID === idApproversGroup).length > 0 &&
                    approversList.filter((item: any) => item.ID === idApproversGroup)[0];
                if (groupApprovers) {
                    approversObj[groupApprovers.Code] = {
                        type: "peoplePicker",
                        key: groupApprovers.Code,
                        require: true,
                        disabled: approversRowDependencies.NotChange,
                        width: "w-full",
                        title: groupApprovers.Title,
                        multiApprove: approversRowDependencies.MultiApprove && "Требуется согласование всей группы" || null,
                        placeholder: groupApprovers.Title,
                        options:
                            approversRowDependencies.Users.length > 0 &&
                            approversRowDependencies.Users.map((item: any) => {
                                const email = item.get_email().toLowerCase();
                                return {
                                    value: users[email] && users[email].email || email,
                                    label: users[email] && users[email].displayName || item.get_lookupValue(),
                                    avatar: users[email] && users[email].avatar || null,
                                };
                            }),
                    };
                    if (approversRowDependencies.NotChange && approversRowDependencies.DefaultApprovers.length > 0) {
                        const tempDefaultValues: any = {};
                        tempDefaultValues[groupApprovers.Code] = [];
                        tempDefaultValues[groupApprovers.Code] = [...tempDefaultValues[groupApprovers.Code], ...approversRowDependencies.DefaultApprovers.map((item: any) => {
                            const email = item.get_email().toLowerCase();
                            return {
                                value: users[email] && users[email].email || email,
                                label: users[email] && users[email].displayName || item.get_lookupValue(),
                                avatar: users[email] && users[email].avatar || null,
                            }
                        })];
                        setDefaultValues((prevState: any) => {
                            return { ...prevState, ...tempDefaultValues }
                        });
                    }
                }
            });
            let fieldsFormUpdate: any = [];
            Object.keys(approversObj).length > 0 &&
                Object.keys(approversObj).map((key: string) => {
                    fieldsFormUpdate = [...fieldsFormUpdate, approversObj[key]];
                });
            setFieldsForm(fieldsFormUpdate);
        }
    }, [approversDependencies, approversList, users]);

    useEffect(() => {
        if (card) {
            getItemsRequest({ listName: approversCardDocumentListName, filters: { Document: card.ID, VersionDocument: versionView && true || false } }).then((result) => {
                setApproversByDocument([...result.items]);
            });
        }
    }, [card]);

    useEffect(() => {
        if (Object.keys(card).length > 0 && (card.Status.ID === docStatuses.revision || card.Status.ID === docStatuses.cancel) && approversList.length > 0 && approversByDocument.length > 0 && approversDependencies.length > 0) {
            const approversGroupCard = approversByDocument.filter((item: any) => item.Group.get_lookupId() !== docApprovers.Creater);
            const tempDefaultValues: any = {};
            approversGroupCard.map((approversRowCard: any) => {
                const codeGroup = approversList.find((approver: any) => approver.ID === approversRowCard.Group.ID)['Code'];
                const idGroup = approversList.find((approver: any) => approver.ID === approversRowCard.Group.ID)['ID'];
                if (Object.keys(_.orderBy(approversDependencies, ['Order0'], ['asc']).find((apDep: any) => apDep.Group.get_lookupId() === idGroup) || {}).length > 0) {
                    if (!Array.isArray(tempDefaultValues[codeGroup])) {
                        tempDefaultValues[codeGroup] = [];
                    }
                    tempDefaultValues[codeGroup] = [...tempDefaultValues[codeGroup], ...approversRowCard.Approvers.map((item: any) => {
                        return {
                            value: users[item.Email] && users[item.Email].email || item.Email,
                            label: users[item.Email] && users[item.Email].displayName || item.Name,
                            avatar: users[item.Email] && users[item.Email].avatar || null,
                        }
                    })];
                }
            });
            setDefaultValues((prevState: any) => {
                return { ...prevState, ...tempDefaultValues }
            });
        }
    }, [approversByDocument, approversList, approversDependencies, users]);

    return (
        <DialogComponent open={open} toggleDialog={dialogToggle}>
            <div className="step_3 md:min-w-[975px] md:max-w-[975px] md:min-h-[75vh]">
                <span className="text-7.5 leading-[38px] font-bold text-black block mb-8">Укажите согласующих</span>
                {statusUsers !== "LOADING" && fieldsForm.length > 0 &&
                    <Form
                        type="approvers_edit"
                        textButtonSubmit="Отправить на согласование"
                        openCancelAddCard={open}
                        setOpenCancelAddCard={setOpen}
                        setFormData={setApprovers}
                        fieldsForm={fieldsForm}
                        updateCardData={updateCardData}
                        setApproversCardDocumentData={setApproversCardDocumentData}
                        setShowEditApprovers={setShowEditApprovers}
                        defaultValues={defaultValues}
                    />
                    || <FlexCol className="px-7.5 py-5 justify-center items-center gap-5">
                        <span className="text-darkblue text-base">Получаем данные согласующих<br />Пожалуйста подождите...</span>
                        <Loading />
                    </FlexCol>}
            </div>
        </DialogComponent>
    );
};

export default EditApproversModal;
